import { useUiStore } from '@/stores/UiStore'
import ContextMenuItem from '../ContextMenuItem'
import { UPDATE_STATUS } from '@/constants/dispatch'

/**
 * Change load's status dispatch context menu item.
 *
 * @author Alejandro Sanchez <asanchez@boltsystem.com>
 */
export default class ChangeStatus extends ContextMenuItem {
    /**
     * Get the action callback function.
     *
     * @return {Function}
     */
    action() {
        return () => {
            const id = this.params.node.data.id

            const uiStore = useUiStore()

            if (id) {
                const selectedRows = this.params?.api?.getSelectedRows() || []
                const ids = selectedRows.map((row) => row.id)

                if (ids.length === 0) {
                    ids.push(this.params.node.data.id)
                }

                uiStore.openAction(UPDATE_STATUS, { id: ids })
            }
        }
    }

    /**
     * The name of the menu item to display.
     *
     * @return {String}
     */
    name() {
        return 'Change Status'
    }

    /**
     * The tooltip to display on hover.
     *
     * @return {String?}
     */
    tooltip() {
        return 'Click to change the status of this column based on the selected value'
    }
}
